/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { FC, ReactElement } from "react"
import { Row, Col } from "@duxton-web/ui"
import { isEmpty } from "lodash"
import Highlighter from "react-highlight-words"
import { OverflowTip } from "components/common/OverflowTip"
import menuItemRowStyles from "pages/menu/detail/menuOverview/lists/MenuItemRow.modules.css"
import { AvailableCount } from "components/common/AvailableCount"
import { SellingTime } from "types/models/menu"
import { SellingTimeTag } from "components/tags"
import { getIsAlwaysAvailable } from "utils/selling_time_helper"

interface MenuOverviewRowProps {
  name: string
  isActive?: boolean
  showItemSelection?: boolean
  count: number
  countNotAvailable?: number
  sellingTime?: SellingTime
  renderBefore?: false | ReactElement
  renderAfter?: false | ReactElement
  isItemWithoutPhotoMode?: boolean
  searchString?: string
}

export const MenuOverviewRow: FC<MenuOverviewRowProps> = ({
  name,
  isActive,
  showItemSelection,
  count,
  countNotAvailable,
  sellingTime,
  renderBefore,
  renderAfter,
  isItemWithoutPhotoMode = false,
  searchString,
}: MenuOverviewRowProps) => {
  const isAlwaysAvailable = getIsAlwaysAvailable(sellingTime)

  return (
    <Row align="middle" wrap={false}>
      {renderBefore && <Col>{renderBefore}</Col>}
      <Col flex="auto">
        <OverflowTip
          style={{
            flexGrow: 1,
            fontWeight: isActive ? 500 : undefined,
          }}
        >
          {isEmpty(searchString) ? (
            name
          ) : (
            <Highlighter
              highlightTag="span"
              highlightClassName={menuItemRowStyles.highlightText}
              autoEscape
              searchWords={[searchString ?? ""]}
              textToHighlight={name ?? ""}
            />
          )}
        </OverflowTip>
      </Col>
      {sellingTime && !isAlwaysAvailable && (
        <Col>
          <SellingTimeTag sellingTime={sellingTime} />
        </Col>
      )}
      <Col
        className={`countWrapper ${
          showItemSelection || isItemWithoutPhotoMode ? "show" : ""
        }`}
      >
        <AvailableCount count={count} countNotAvailable={countNotAvailable} />
      </Col>
      {renderAfter && <Col>{renderAfter}</Col>}
    </Row>
  )
}
